import { SelectList } from 'complex-data'
import { SelectListValueType } from 'complex-data/src/data/SelectList'

export class SelectListWithRelation<D extends SelectListValueType = SelectListValueType<unknown>> extends SelectList<D> {
  getRelation(value: unknown, offset = 1, prop: keyof D = 'value') {
    const item = this.getItem(value, prop)
    if (this.miss === item) {
      return undefined
    } else {
      const index = this.list.indexOf(item as D)
      return this.getIndex(index + offset)
    }
  }
  getIndex(index: number) {
    return this.list[index]
  }
}
